import ms from 'milliseconds'

import createListBundle from '~/src/Lib/createListBundle'
import { LightSchedule as schema } from '~/src/Store/Schemas'

const initialState = {
  room: null,
  start: null,
  end: null,
}

export default createListBundle({
  entityName: 'lightSchedule',
  initialState,
  schema,
  retryAfter: ms.seconds(5),
  staleAfter: ms.minutes(60),
  fetchHandler: ({ apiFetch, params }) => apiFetch('/lightSchedules/', params),
  urlTest: url => url.match(/\/rooms\/\d+/),
})
